export const BasicCarDataFields = {
  REGISTRATION_PLATE: 'registrationPlate',
  MAKE_SELECT: 'makeSelect',
  MODEL_SELECT: 'modelSelect',
  MILEAGE: 'mileage',
  YEAR: 'year',
  MOT: 'mot',
  DERIVATIVE: 'derivative',
  CAR_TYPE: 'carType',
  TRANSMISSION: 'transmission',
  ENGINE_SIZE: 'engineSize',
  FUEL: 'fuel',
  COLOUR: 'colour',
  DOORS: 'doors',
  DATE_OFF_FIRST_REGISTRATION: 'dateOfFirstRegistration',
  PREVIOUS_KEEPERS_IN_TOTAL: 'previousKeepersInTotal',
  VIN: 'vin',
  VEHICLE_CAP_ID: 'vehicleCapCapId',
};

export const BasicCarDataFieldsName = {
  REGISTRATION_PLATE: 'Registration Number',
  MILEAGE: 'Mileage',
  YEAR: 'Year',
  MOT: 'MOT',
  CAR_TYPE: 'Body Type',
  TRANSMISSION: 'Transmission',
  ENGINE_SIZE: 'Engine Size',
  FUEL: 'Fuel',
  COLOUR: 'Colour',
  DOORS: 'Doors',
  DATE_OFF_FIRST_REGISTRATION: 'Date of Registration',
  PREVIOUS_KEEPERS_IN_TOTAL: 'Previous Keepers',
  VIN: 'VIN / Chassis No.',
  LOCATION: 'Location',
  MAKE: 'Make',
  MODEL: 'Model',
  DERIVATIVE: 'Derivative',
  NUMBER_OF_KEYS: 'Number of keys included',
  LOGBOOK_STATUS: 'V5C logbook status',
  ULEZ: 'ULEZ compliant',
  VEHICLE_TYPE: 'Vehicle Type',
  VAT_QUALIFYING: 'Vat Qualifying',
};
